import { Icon } from '@iconify/react/dist/iconify.js';
import { Box, Button, Chip, Typography } from '@mui/material';
import { ActionButtonNew, UpdateButton, UpdateButtonNew, ViewButtonNew } from '../../mui/Buttons/Buttons';
import ToolTip from '../../ToolTip/ToolTip';

export const REFUND_SCHEDULED_PAYMENT_TABLE_HEAD = ({ nonEnrollment, setOpenModalComponentName, setSelectedRow }) => {
  const buttonAction = (selectedRowDetails, componentName) => {
    setSelectedRow(selectedRowDetails);
    setOpenModalComponentName(componentName);
  };

  return [
    {
      field: 'sl_no',
      headerName: 'Sl No',
      width: 100,
    },
    {
      field: nonEnrollment ? 'lead_id' : 'admn_no',
      headerName: 'Admission No',
      width: 150,
    },
    {
      field: 'student_name',
      headerName: 'Student Name',
      width: 300,
      renderCell: ({ row }) => {
        return `${row.student_name}  (${nonEnrollment ? row.lead_id : row.admn_no})`;
      },
    },
    {
      field: 'croName',
      headerName: 'CRO Name',
      width: 200,
      valueGetter: ({ row }) => row.croName || 'Nill',
    },
    {
      field: 'ogaName',
      headerName: 'OGA Name',
      width: 200,
    },
    {
      field: 'course_name',
      headerName: 'Course Name',
      width: 250,
      renderCell: (params) => {
        return <ToolTip expand={params.row.course_name} content={params.row.course_name} />;
      },
    },
    {
      field: 'completed_sessions',
      headerName: 'Sessions Completed',
      width: 150,
    },
    {
      field: 'total_sale_amount',
      headerName: 'Total Sale Amount',
      width: 150,
    },
    {
      field: 'total_fee_collected',
      headerName: 'Total Fee Collected',
      width: 150,
    },
    {
      field: nonEnrollment ? 'holdamount_refund_amount' : 'expense_amount',
      headerName: 'Refund Amount',
      width: 150,
    },
    {
      field: nonEnrollment ? 'holdamount_refund_scheduled_date' : 'scheduled_date',
      headerName: 'Scheduled Payment Date',
      width: 200,
    },

    {
      field: 'payment_status',
      headerName: 'Payment Status',
      width: 150,
      renderCell: (params) => {
        if (nonEnrollment ? params.row.holdamount_refund_transaction_date : params.row.expense_transaction_date) {
          return <Chip variant="outlined" color="success" label="Paid" />;
        } else {
          return <Chip variant="outlined" color="warning" label="Pending" />;
        }
      },
    },

    {
      field: 'Account Details',
      headerName: 'Bank Details',
      width: 150,
      renderCell: ({ row }) => <ViewButtonNew onClick={() => buttonAction(row, 'Bank Details')} />,
    },
    {
      field: nonEnrollment ? 'holdamount_refund_transaction_date' : 'expense_transaction_date',
      headerName: 'Transaction date',
      width: 250,
      renderCell: ({ value, row }) => (
        <Box sx={{ display: 'flex', width: '100%', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography>{value || 'Nill'}</Typography>
          <UpdateButtonNew disabled={!value} onClick={() => buttonAction(row, 'Update Transaction Date')} />
        </Box>
      ),
    },
    {
      field: 'actions',
      headerName: 'Action',
      width: 200,
      renderCell: ({ row }) => {
        const disabled = nonEnrollment ? row.holdamount_refund_transaction_date : row.expense_transaction_date;
        // const disabled=false
        {
          return (
            <Box display={'flex'} gap={1}>
              <ActionButtonNew
                onClick={() => buttonAction(row, 'Mark As Paid')}
                color={'success'}
                children="Mark As Paid"
                disabled={disabled}
                startIcon={<Icon width={20} height={20} icon={'mdi:tick-decagram'} />}
              />
            </Box>
          );
        }
      },
    },
  ];
};
